module.exports = __webpack_public_path__ + "img/icon-lego-ai.78e12138.svg";